import { CardComp } from "../cardComp";
import PermissionListSkeletonLoader from "./PermissionListSkeletonLoader";
import styled from "styled-components";

const SkeletonPulse = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: roleFormSkeletonPulse 1.5s ease-in-out infinite;
  border-radius: 4px;

  @keyframes roleFormSkeletonPulse {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const RoleFormSkeletonLoader = () => {
  return (
    <div aria-busy="true" aria-label="Loading role form">
      <CardComp
        cardClassName={"pt-4 mb-4"}
        cardBodyClassName={"py-0 row gx-5 gy-3 justify-content-between"}
      >
        <div className="col-12 col-lg-5">
          {[1, 2].map((field) => (
            <div key={field} className={field > 1 ? "mt-3" : ""}>
              <SkeletonPulse
                style={{ height: "14px", width: "120px", marginBottom: "8px" }}
              />
              <SkeletonPulse
                style={{
                  height: field === 2 ? "80px" : "42px",
                  width: "100%",
                  borderRadius: "5px",
                }}
              />
            </div>
          ))}
        </div>
        <div className="col-12 col-lg-6">
          <SkeletonPulse
            style={{ height: "16px", width: "140px", marginBottom: "8px" }}
          />
          <SkeletonPulse
            style={{ height: "12px", width: "90%", maxWidth: "360px", marginBottom: "16px" }}
          />
          <PermissionListSkeletonLoader rows={8} />
        </div>
        <div className="col-12 py-1" />
      </CardComp>
      <div className="d-flex gap-3">
        <SkeletonPulse style={{ height: "48px", width: "160px", borderRadius: "10px" }} />
        <SkeletonPulse style={{ height: "48px", width: "120px", borderRadius: "10px" }} />
      </div>
    </div>
  );
};

export default RoleFormSkeletonLoader;
